import { Routes } from "@angular/router";
import { importProvidersFrom, Injector } from "@angular/core";
import {
  ConnectionHttpService,
  SOFTLINE_SERVICE_HTTP,
  SOFTLINE_STORE_DETAIL_SERVICE_FACTORY,
  SOFTLINE_STORE_ENTITY_SERVICE, SOFTLINE_STORE_QUERY_SERVICE,
  SoftlineEntityDetailService,
  SoftlineEntityService, SoftlineQueryService,
  StoreModule
} from "@softline/core";
import { AuthenticationGuard, AuthorizationGuard } from "@softline/auth";
import { BeweAuStore, BewePrStore, FilterStore, ProduktionsauftragStore } from "./store";
import {
  SOFTLINE_CONST_PRODUKTIONSAUFTRAG_REZEPTLISTE,
  SOFTLINE_CONST_PRODUKTIONSAUFTRAG_ZUSATZDATEN,
  SOFTLINE_FEATURE_PRODUKTIONSAUFTRAG_BEWEAU,
  SOFTLINE_FEATURE_PRODUKTIONSAUFTRAG_BEWEPR,
  SOFTLINE_FEATURE_PRODUKTIONSAUFTRAG_FILTER,
  SOFTLINE_FEATURE_PRODUKTIONSAUFTRAG_QUERY,
  SOFTLINE_PERMISSION_PRODUKTIONSAUFTRAG,
  SOFTLINE_SERVICE_PRODUKTIONSAUFTRAG_REZEPTLISTE,
  SOFTLINE_SERVICE_PRODUKTIONSAUFTRAG_ZUSATZDATEN
} from "./produktionsauftrag.shared";
import {
  SOFTLINE_API_PRODUKTIONSAUFTRAG_BEWEAU,
  SOFTLINE_API_PRODUKTIONSAUFTRAG_BEWEPR,
  SOFTLINE_API_PRODUKTIONSAUFTRAG_QUERY
} from "./produktionsauftrag.api";
import {RezepturBeweService} from './services/rezeptur-bewe.service';
import {KopfprService} from './services/kopfpr.service';

export const produktionsauftragRoutes: Routes = [
  {
    path: 'produktionsauftrag',
    children: [
      {
        path: ':id',
        loadComponent: () =>
          import('./pages/produktionsauftrag-detail/produktionsauftrag-detail.page').then(
            (o) => o.ProduktionsauftragDetailPage
          ),
      },
      {
        path: '',
        loadComponent: () =>
          import('./pages/produktionsauftrags-liste/produktionsauftrags-liste.component').then(
            (o) => o.ProduktionsauftragsListeComponent
          ),
      },
    ],
    canActivate: [AuthenticationGuard, AuthorizationGuard],
    data: { permission: SOFTLINE_PERMISSION_PRODUKTIONSAUFTRAG },
    providers: [
      importProvidersFrom(
        StoreModule.forFeature({
          name: SOFTLINE_FEATURE_PRODUKTIONSAUFTRAG_QUERY,
          feature: ProduktionsauftragStore.feature,
          providers: [
            {
              provide: SOFTLINE_STORE_ENTITY_SERVICE,
              useFactory: (service: ConnectionHttpService) => new SoftlineEntityService(service, SOFTLINE_API_PRODUKTIONSAUFTRAG_BEWEPR),
              deps: [SOFTLINE_SERVICE_HTTP],
            },
            {
              provide: SOFTLINE_STORE_QUERY_SERVICE,
              useFactory: (service: ConnectionHttpService) => new SoftlineQueryService(service, SOFTLINE_API_PRODUKTIONSAUFTRAG_QUERY),
              deps: [SOFTLINE_SERVICE_HTTP],
            }
          ],
        }),
        StoreModule.forFeature({
          name: SOFTLINE_FEATURE_PRODUKTIONSAUFTRAG_BEWEAU,
          feature: BeweAuStore.feature,
          providers: [
            {
              provide: SOFTLINE_STORE_ENTITY_SERVICE,
              useFactory: (service: ConnectionHttpService) => new SoftlineEntityService(service, SOFTLINE_API_PRODUKTIONSAUFTRAG_BEWEAU),
              deps: [SOFTLINE_SERVICE_HTTP],
            },
          ],
        }),
        StoreModule.forFeature({
          name: SOFTLINE_FEATURE_PRODUKTIONSAUFTRAG_FILTER,
          feature: FilterStore.feature
        }),
        StoreModule.forFeature({
          name: SOFTLINE_FEATURE_PRODUKTIONSAUFTRAG_BEWEPR,
          feature: BewePrStore.feature,
          providers: [
            {
              provide: SOFTLINE_STORE_ENTITY_SERVICE,
              useFactory: (service: ConnectionHttpService) => new SoftlineEntityService(service, SOFTLINE_API_PRODUKTIONSAUFTRAG_BEWEPR),
              deps: [SOFTLINE_SERVICE_HTTP],
            }, {
              provide: SOFTLINE_STORE_DETAIL_SERVICE_FACTORY,
              useValue: (name: string, injector: Injector) => {
                switch (name) {
                  case SOFTLINE_CONST_PRODUKTIONSAUFTRAG_ZUSATZDATEN:
                    return injector.get(SOFTLINE_SERVICE_PRODUKTIONSAUFTRAG_ZUSATZDATEN);
                  case SOFTLINE_CONST_PRODUKTIONSAUFTRAG_REZEPTLISTE:
                    return injector.get(SOFTLINE_SERVICE_PRODUKTIONSAUFTRAG_REZEPTLISTE);
                  default:
                    throw new Error(`ProduktionsauftragModule - No detail service found for ${name}`);
                }
              },
            },
            {
              provide: RezepturBeweService,
              useClass: RezepturBeweService
            },
            {
              provide: KopfprService,
              useClass: KopfprService
            },
            {
              provide: SOFTLINE_SERVICE_PRODUKTIONSAUFTRAG_ZUSATZDATEN,
              useFactory: (service: ConnectionHttpService) => new SoftlineEntityDetailService(service, SOFTLINE_API_PRODUKTIONSAUFTRAG_BEWEPR, SOFTLINE_CONST_PRODUKTIONSAUFTRAG_ZUSATZDATEN),
              deps: [SOFTLINE_SERVICE_HTTP],
            },
            {
              provide: SOFTLINE_SERVICE_PRODUKTIONSAUFTRAG_REZEPTLISTE,
              useFactory: (service: ConnectionHttpService) => new SoftlineEntityDetailService(service, SOFTLINE_API_PRODUKTIONSAUFTRAG_BEWEPR, SOFTLINE_CONST_PRODUKTIONSAUFTRAG_REZEPTLISTE),
              deps: [SOFTLINE_SERVICE_HTTP],
            },
          ],
        })
      ),
    ],
  },
];
